import invariant from "fbjs/lib/invariant";
import { currenciesAllowedList } from "./Price";

export const formatPrice = (intl, { value }) => {
  invariant(
    currenciesAllowedList.indexOf(value.currency) > -1,
    `"${value.currency}" is not on the allowed currency list`
  );
  return intl.formatNumber(value.amount, {
    style: "currency",
    currency: value.currency,
  });
};
